import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useDeviceType, MOBILE_SCREEN } from '@travel/traveler-core/hooks';

import { isInDisplayedPeriod } from 'utils/cwdContent';

import { basePaths } from 'constants/paths';

import { getLocation } from 'store/__router/selectors';
import { getPCItem, getSPItem } from 'store/banner/selectors';

import styles from './banner.module.scss';

type Props = { className?: string; fetchPriority?: 'high' | 'low' | 'auto' };

function Banner(props: Props) {
  const isSP = useDeviceType() === MOBILE_SCREEN;
  const item = useSelector(isSP ? getSPItem : getPCItem);

  const location = useSelector(getLocation);
  const isValidPath = useMemo(
    () =>
      !location.pathname.includes(basePaths.providerListMap) &&
      [basePaths.providerList, basePaths.plansList, basePaths.planDetail].some((path) =>
        location.pathname.includes(path),
      ),
    [location.pathname],
  );

  const validItem = useMemo(() => {
    const shouldBeDisplayed = isInDisplayedPeriod(item?.start_time, item?.end_time);
    return shouldBeDisplayed ? item : null;
  }, [item]);

  if (!validItem || !isValidPath || !validItem.img) return null;

  return (
    <div
      className={props.className}
      data-testid="banner-wrapper"
      id="banner-wrapper"
      style={{ background: item?.backcolor || '#eaeaea' }}
    >
      <a href={validItem.href} className={styles.link}>
        <img
          // @ts-ignore
          fetchPriority="high"
          className={styles.img}
          src={validItem.img}
          alt={validItem.alt || ''}
          loading="eager"
        />
      </a>
    </div>
  );
}

export default Banner;
